import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const HIDDEN_PATHS = new Set(['/login', '/unauthorized']);

// `pathname` comes from the shell rather than the router: tabbed, this renders
// outside every tab's router and has none to read.
export default function NavigationBar({
  canGoBack,
  canGoForward,
  goBack,
  goForward,
  currentLabel,
  pathname = '/',
}) {
  if (HIDDEN_PATHS.has(pathname)) return null;

  return (
    <>
      {/* Mobile: rendered inside the mobile header via a portal-like pattern — see App.js */}
      <div className="mobile-nav-back-forward">
        <button
          onClick={goBack}
          disabled={!canGoBack}
          className="mobile-nav-btn"
          aria-label="Go back"
        >
          <ArrowLeft size={18} />
        </button>
        <button
          onClick={goForward}
          disabled={!canGoForward}
          className="mobile-nav-btn"
          aria-label="Go forward"
        >
          <ArrowRight size={18} />
        </button>
      </div>

      {/* Desktop: thin bar at top of content area */}
      <div className="hidden md:flex items-center h-9 px-3 bg-surface border-b border-gray-200 flex-shrink-0">
        <div className="flex items-center gap-1">
          <button
            onClick={goBack}
            disabled={!canGoBack}
            className="flex items-center justify-center w-7 h-7 rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700 active:bg-gray-200 disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-gray-500 disabled:cursor-default transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft size={18} />
          </button>
          <button
            onClick={goForward}
            disabled={!canGoForward}
            className="flex items-center justify-center w-7 h-7 rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700 active:bg-gray-200 disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-gray-500 disabled:cursor-default transition-colors"
            aria-label="Go forward"
          >
            <ArrowRight size={18} />
          </button>
        </div>
        {currentLabel && (
          <span className="ml-3 text-sm font-medium text-gray-400 truncate select-none">
            {currentLabel}
          </span>
        )}
      </div>
    </>
  );
}
